import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['logical'] = function (block: Blockly.Block): [string, number] {
        const a = gen.valueToCode(block, 'A', 0) || 'false';
        const b = gen.valueToCode(block, 'B', 0) || 'false';
        const op = block.getFieldValue('OP');

        const opMap: Record<string, string> = {
            AND: '&&',
            OR: '||',
        };

        return expr(`${a} ${opMap[op]} ${b}`);
    };
}
